import React from 'react';

import Avatar from 'components/Avatar';

import './styles.css';

const TeamBox = ({avatar, name, isOwner, onClick}) => (
  <div className="TeamBox" onClick={onClick}>
    <Avatar url={avatar} initials="" />
    <div className="name">{name}</div>
    <div className="teamStatus">
      {isOwner && 'Owner'}
      {!isOwner && 'Team Member'}
    </div>
  </div>
);

export default TeamBox;
